import classNames from 'classnames';
import { Button } from '@heroui/button';

interface ProgressionSquareProps {
  number: number;
  active?: boolean;
  onClick?: () => void;
}

function ProgressionSquare({ number, active = false, onClick }: ProgressionSquareProps) {
  return (
    <Button
      className={classNames(
        'border-2 border-dashed rounded-lg w-14 h-14 sm:w-16 sm:h-16 min-w-0 p-0 flex items-center justify-center',
        {
          ['opacity-100']: active,
          ['border-default-500 text-default-500']: !active,
        }
      )}
      variant="light"
      onPress={onClick}
    >
      {number}
    </Button>
  );
}

export default ProgressionSquare;
